module.exports = __webpack_public_path__ + "static/media/build_course.e9034752.svg";